import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {playistEndpoint} from '../_constants/api.constant'
export async function getAllPlaylistOfUser(paramsObj) {
    const response = await axios.get(
        playistEndpoint.GETALLOFUSER,
        {   params:paramsObj,
            headers: {
                'Authorization': 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        return error.response;
    });
    return response
}